export enum ELinkType {
  LINK_TO = 'link-to',
  BE_LINKED = 'be-linked',
}

export enum ENumberType {
  INCREASE = 'increase',
  DECREASE = 'decrease',
}
